import { Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { ScheduleSelectorService } from '../../services/schedule-selector.service';

@Component({
  selector: 'schedule-selector',
  templateUrl: './schedule-selector.component.html',
  styleUrls: ['./schedule-selector.component.scss'],
  standalone: false,
})
export class ScheduleSelectorComponent {
  @ViewChild('tooltipTrigger') tooltipTrigger: ElementRef;
  @Input() additionalTooltipClass: string;

  filterConfig = {
    placeholder: 'Search schedules',
  };
  search: any = {
    sortBy: 'changeDate',
    reverse: true,
  };

  protected scheduleSelectorService = inject(ScheduleSelectorService);

  openDialog() {
    this.scheduleSelectorService.openDialog();
  }

  select() {
    this.scheduleSelectorService.select();
  }

  addSchedule() {
    this.scheduleSelectorService.addSchedule();
  }

  editSchedule(schedule: any) {
    this.scheduleSelectorService.editSchedule(schedule);
  }

  filterSchedule(schedule: any): boolean {
    let query = this.scheduleSelectorService.search?.query;

    return (
      !query || schedule?.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
}
